import { render } from "./SubscriptionsPanel.vue?vue&type=template&id=a5828168&ts=true"
import script from "./SubscriptionsPanel.vue?vue&type=script&lang=ts"
export * from "./SubscriptionsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__